<template>
  <div class="container">
    <div class="top-gif">
      <div class="img-text-container">
        <div class="text-logo">
          <div class="site-brand" aria-label="优艺AI">优艺AI</div>
        </div>
        <div class="text-middle">
          <div class="text-middle-one">优艺AI</div>
          <div class="text-middle-two">AI辅助生成式设计项目展示</div>
        </div>
        <div class="bottom-button" @click="toLogin()">
          <div class="button-bg">
            <img src="../assets/kaiping/arrow.png" alt="" />
            <span>前往探索</span>
          </div>
        </div>
      </div>
      <img src="../assets/kaiping_gif.gif" alt="" class="kaiping-gif" />
    </div>
    <div class="kaiping-carousel">
      <el-carousel
        :interval="4000"
        type="card"
        height="672px"
        class="carousel-container"
        arrow="always"
      >
        <el-carousel-item v-for="item in kaipingImgs" :key="item">
          <img
            :src="item"
            alt=""
            class="carsouel-img carousel-item-img"
            style="
              object-fit: scale-down;
              /* width: 100%; */
              /* border: 1px solid #f00; */
            "
          />
          <!-- <div
            :style="{
              'object-fit': ' scale-down',
              background: 'url(' + item + ') no-repeat',
            }"
            class="carousel-item-img"
          ></div> -->
        </el-carousel-item>
        <!-- <div style="color: brown">123</div> -->
      </el-carousel>
      <div class="carousel-bottom-text" style="color: brown">
        <div class="bottom-text-center">
          <div class="bottom-left-text">
            <div class="left-top-text">AI辅助工业设计项目展示</div>
            <div class="left-middle-text">
              展示生成式设计、三维模型与产品概念相关研究和演示内容
            </div>
          </div>
          <div class="bottom-right-text">
            <div
              class="bottom-right-text-bottom"
              @click="toLogin()"
              style="cursor: pointer"
            >
              <img src="../assets/kaiping/more_arrow.png" alt="" />
              <div class="more-production">查看更多演示</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="site-footer">
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
      >
        浙ICP备2024131002号
      </a>
    </footer>
  </div>
</template>

<script>
import kaipingImg01 from "../assets/kaiping/model01.png";
import kaipingImg02 from "../assets/kaiping/model02.png";
import kaipingImg03 from "../assets/kaiping/model03.png";
import kaipingImg04 from "../assets/kaiping/model04.png";
import kaipingImg05 from "../assets/kaiping/model05.png";
export default {
  data() {
    return {
      kaipingImgs: [
        //轮播图的src
        kaipingImg01,
        kaipingImg02,
        kaipingImg03,
        kaipingImg04,
        kaipingImg05,
      ],
    };
  },
  components: {},

  methods: {
    toLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  // gap: 40px;
  color: #fff;
  // align-items: center;
  .top-gif {
    position: relative;
    .kaiping-gif {
      width: 100%;
      height: 774px;
    }
    .img-text-container {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      // padding: 41px 0 0 65px;
      padding-left: 65px;
      padding-top: 41px;
      // gap: 40px;
      .text-logo {
        display: flex;
        align-items: center;
        gap: 29px;
        color: #fff;
        .site-brand {
          font-size: 34px;
          font-weight: 700;
          line-height: 44px;
          letter-spacing: 0;
        }
      }
      .text-middle {
        margin-top: 134px;
        display: flex;
        flex-direction: column;
        gap: 47px;
        .text-middle-one {
          font-size: 68px;
          font-weight: 700;
          line-height: 86px;
        }
        .text-middle-two {
          font-size: 36px;
          font-weight: 290;
          line-height: 46px;
        }
      }
      .bottom-button {
        width: 241px;
        height: 106px;
        margin-top: 125px;
        .button-bg {
          display: flex;
          padding: 0 24px;
          align-items: center;
          // justify-content: center;
          // gap: 12px;
          width: 241px;
          height: 106px;
          cursor: pointer;
          // background: rgba(255, 255, 255, 0.75);
          background: url("../assets/kaiping/bg_button.png") no-repeat;
          span {
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
            color: #155868;
          }
        }
      }
    }
  }
  .kaiping-carousel {
    position: relative;
    display: flex;
    justify-content: center;
    .carousel-bottom-text {
      position: absolute;
      width: 100%;
      bottom: 33px;
      display: flex;
      justify-content: center;
      padding-left: 12px;
      .bottom-text-center {
        width: 679px;
        height: 112px; // height: 135px;
        display: flex;
        justify-content: space-between;
        .bottom-left-text {
          padding: 0 16px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          color: #0047ba;
          // margin-top: 24px;
          .left-top-text {
            font-size: 20px;
            font-weight: 400;
            line-height: 26px;
          }
          .left-middle-text {
            font-size: 12px;
            font-weight: 290;
            line-height: 16px;
            opacity: 0.75;
          }
        }
        .bottom-right-text {
          text-align: right;
          .bottom-right-text-bottom {
            height: 100%;
            display: flex;
            flex-direction: column;
            // align-items: right;
            justify-content: end;
            .more-production {
              color: #0047ba;
              opacity: 0.75;
              font-size: 12px;
              font-weight: 290;
              line-height: 16px;
              border-bottom: #0047ba solid 2px;
              padding-bottom: 8px;
            }
          }
          // display: flex;
        }
      }
    }
  }
  .carousel-container {
    width: 1920px;
    display: flex;
    flex-direction: column;
    ::v-deep .el-carousel__arrow {
      width: 52px;
      height: 52px;
      background: #fff;
      .el-icon-arrow-left {
        font-size: 24px;
        font-weight: 1000;
        color: #0047ba;
      }
      .el-icon-arrow-right {
        font-size: 24px;
        font-weight: 1000;
        color: #0047ba;
      }
    }
    ::v-deep .el-carousel__arrow--left {
      left: 606px;
    }
    ::v-deep .el-carousel__arrow--right,
    .el-notification.right {
      right: 606px;
    }
    .el-carousel__item--card {
      width: 960px;
      // margin-left: 10%;
    }
    .el-carousel__item {
      .carousel-item-img {
        width: 960px;
        // height: (476/679) * 960px;
        // height: 100%;
      }
    }
    // ::v-deep .el-carousel__indicators--outside {
    //   bottom: 26px;
    //   text-align: left;
    //   position: static;
    //   transform: none;
    // }
    ::v-deep .el-carousel__indicators {
      width: 672px;
      margin-top: 148px !important;
      align-self: center;
      text-align: left;
      // width: 66vw !important;
      // margin-left: 34vw;
      // text-align: left;

      .el-carousel__indicator--horizontal {
        display: inline-block;
        padding: 12px 16px;
        .el-carousel__button {
          width: 60px;
          height: 4px;
          background: #0047ba;
        }
        ::v-deep .el-carousel__indicators--outside button {
          background-color: #0047ba !important;
          opacity: 0.24;
        }
      }
    }
  }
}
.site-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  background: #fff;
  border-top: 1px solid rgba(0, 71, 186, 0.12);
  a {
    color: #5f6b7a;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none;
  }
  a:hover {
    color: #0047ba;
  }
}
</style>
